export default __webpack_public_path__ + "static/media/2378.82de10cc.png";